export default __webpack_public_path__ + "static/media/qc-city-logo.c470d34f.svg";